import apiRequest from "../api/apiRequest";
import { apiConfig } from "../config/apiConfig";
import { REGEX } from "../constants/regex";
import { handleFakeSubmit, hmsProgressBarUpdate, removeAllEventListeners } from "../util/share";

interface ValidationOptions {
    type: 'firstName' | 'lastName' | 'email' | 'confirmEmail';
    required?: boolean;
    regex?: RegExp;
    matchFieldId?: string;
    emptyMsg?: string;
    invalidMsg?: string;
    mismatchMsg?: string;
}

interface Window {
    sharedData?: Record<string, any>;
}

export class GiftPurchase {
    readonly PHONE_NUMBER_LENGTH: number = 14;

    constructor() {
        this.init();
    }

    private init() {
        this.addNextBtnEventListener();
        this.addInputEventListeners();
        this.backBtn();

        const phoneNumberInput = document.getElementById(`purchaser-phone-number`) as HTMLInputElement;

        if(phoneNumberInput){
            phoneNumberInput.addEventListener('input', this.handleMobileInput.bind(this));
        }
        
    }

    private backBtn() {

        const backButton = removeAllEventListeners('#gc-purchaser-details .btn-cancel');
        if (backButton) {
            backButton.addEventListener('click', this.handleBackButtonClick.bind(this));
        }
    }

    private handleBackButtonClick() {
        const step1 = document.getElementById("gc-recipients-details");
        const step2 = document.getElementById("gc-purchaser-details");
        hmsProgressBarUpdate('0%', 0);
        window.scrollTo(0,0);

        step1?.classList.add('form-step-active');
        step2?.classList.remove('form-step-active');
    }

    private addNextBtnEventListener() {
        const nextButton = removeAllEventListeners('#gc-purchaser-details .submit-gift');
        if (nextButton) {
            nextButton.addEventListener('click', this.handleNextButtonClick.bind(this));
        }
    }

    private handleNextButtonClick() {
        if (this.isValidForm()) {
            const firstNameInput = (document.getElementById(`purchaser-first-name`) as HTMLInputElement | null)?.value;
            const lastNameInput = (document.getElementById(`purchaser-last-name`) as HTMLInputElement | null)?.value;
            const phoneNumber = (document.getElementById(`purchaser-phone-number`) as HTMLInputElement | null)?.value;
            const emailInput = (document.getElementById(`purchaser-email`) as HTMLInputElement | null)?.value;

            if (window?.giftRecipient) {
                window.giftRecipient = window.giftRecipient.map((dd: Record<string, any>) => {
                    if (dd) {
                        return {
                            ...dd,
                            PurchaserEmail: emailInput,
                            PurchaserFirstName: firstNameInput,
                            PurchaserLastName: lastNameInput,
                            PurchaserPhoneNumber: phoneNumber,
                            PurchaserPhoneType: "",
                            Campaign: ""
                        };
                    }
                    return dd;
                });

                this.prePurchaseCertificate();
            }
        }
    }

    private async prePurchaseCertificate() {
        try {
            const apiUrl = `${process.env.JS_CORE_API_BASE_URL}/GiftCertificateGroups/PrePurchase`;

            if (window?.giftRecipient) {
                let request = {
                    method: 'POST',
                    url: apiUrl,
                    data: window?.giftRecipient
                };

                 //handle fake submit
                if (request?.data[0]?.PurchaserFirstName?.toLowerCase().includes("isfakesubmit")) {
                    request.data = request?.data[0];
                    handleFakeSubmit(request).then(() => {
                        console.log("Fake Submit Request triggered");
                    }).catch((error) => {
                        console.error("Error in Fake Submit:", error);
                    }).finally(() => {
                        this.naviateToConfirmation();
                    });
                    return true;
                }
                const prePurchaseRes: any = await apiRequest(request);
                
                if(prePurchaseRes){
                    const invoicenNumber = prePurchaseRes?.GiftCertificateGroupId
                    const paymentPostUrl = `${apiConfig.paymentPostUrl}?invoicenumber=${invoicenNumber}&appkey=${process.env.JS_MERCHANT_KEY}`
                    console.log(paymentPostUrl,'PaymentPostUrl');
                    //  const step1 = document.querySelectorAll(".contact-us-section.form-step") as NodeListOf<Element>;
                    // let form = step1[0] as HTMLFormElement;
                        const form = removeAllEventListeners('#gc-purchaser-details')
                        if(form) {
                            form.action = paymentPostUrl;
                            form.method = 'POST';
                            form.submit();
                        }
                }
            }
        } catch (error) {
            const errorModal = document.querySelector<HTMLElement>('.gift-certificate-form #error-modal');

            if (errorModal) {
                errorModal.classList.remove('hidden');
                document.querySelector<HTMLAnchorElement>('#gc-error-modal-btn')?.click();
            }
        }
    }
    naviateToConfirmation() {
        window.history.replaceState({}, '', '/gift-certificate/confirmation/?result_msg=APPROVAL');
        window.location.href = '/gift-certificate/confirmation/?result_msg=APPROVAL'
    }


    private addInputEventListeners() {
        const inputs = document.querySelectorAll('#gc-purchaser-details input');
        inputs.forEach((input: any) => {
            input?.addEventListener('input', this.handleInputEvent.bind(this, input));
        });
    }

    private handleInputEvent(input: HTMLInputElement | HTMLTextAreaElement) {
        if (!input?.name) return;

        const errors: Record<string, string> = {};
        const name = input.name.toLowerCase();

        if (name.includes('first-name')) {
            this.validateField(input, errors, {
                type: 'firstName',
                required: true,
                regex: REGEX.sendName,
                emptyMsg: 'Please enter a valid first name',
                invalidMsg: 'Please enter a valid first name'
            });
        } else if (name.includes('last-name')) {
            this.validateField(input, errors, {
                type: 'lastName',
                required: true,
                regex: REGEX.sendName,
                emptyMsg: 'Please enter a valid last name',
                invalidMsg: 'Please enter a valid last name'
            });
        } else if (name.includes('email')) {
            if (name.includes('confirm')) {
                this.validateField(input, errors, {
                    type: 'confirmEmail',
                    required: true,
                    matchFieldId: 'purchaser-email',
                    emptyMsg: 'Please confirm the email address',
                    mismatchMsg: 'Email addresses do not match'
                });
            } else {
                this.validateField(input, errors, {
                    type: 'email',
                    required: true,
                    regex: REGEX.sendEmail,
                    emptyMsg: 'Please enter a valid email address',
                    invalidMsg: 'Please enter a valid email address'
                });
            }
        }
        if (Object.keys(errors).length > 0) {
            this.showErrors(errors);
        }
        if (!errors[input?.id]) {
            this.clearFieldError(input?.id);
        }
    }

    private showErrors(errors: Record<string, string>) {
        if (!errors || typeof errors !== 'object') return;

        Object.entries(errors).forEach(([fieldId, errorMessage]) => {
            const field = document.getElementById(fieldId);
            const fieldError = document.getElementById(`${fieldId}-error-msg`);

            field?.classList?.add("invalid-field");

            if (fieldError) {
                fieldError.textContent = errorMessage;
                fieldError.classList.remove('hidden');
            }
        });

        const firstErrorFieldId = Object.keys(errors)[0];
        if (firstErrorFieldId) {
            document.getElementById(firstErrorFieldId)?.focus();
        }
    }

    // Validate name fields (first name, last name)
    private validateNameField(field: HTMLInputElement | HTMLTextAreaElement, errors: Record<string, string>, fieldType: 'firstName' | 'lastName', regex?: RegExp, invalidMsg?: string) {
        if (!field?.value || (regex && !regex.test(field.value))) {
            errors[field.id] = invalidMsg ?? `Please enter a valid ${fieldType === 'firstName' ? 'first' : 'last'} name`;
        }
    }

    // Validate email field
    private validateEmailField(field: HTMLInputElement | HTMLTextAreaElement, errors: Record<string, string>, regex?: RegExp, invalidMsg?: string) {
        if (!field?.value || (regex && !regex.test(field.value))) {
            errors[field.id] = invalidMsg ?? 'Please enter a valid email address';
        }
    }

    // Validate confirm email field
    private validateConfirmEmail(field: HTMLInputElement | HTMLTextAreaElement, errors: Record<string, string>, matchFieldId: string, mismatchMsg?: string) {
        if (!field?.id) return;

        const matchField = document.getElementById(matchFieldId) as HTMLInputElement | null;
        if (!field.value || !matchField?.value || field.value !== matchField.value) {
            errors[field.id] = mismatchMsg ?? 'Email addresses do not match';
        }
    }

    // Generic field validator to reduce duplication
    private validateField(field: HTMLInputElement | HTMLTextAreaElement, errors: Record<string, string>, opts: ValidationOptions) {
        if (field?.value === '') {
            this.hideError(field?.id);
            return;
        }
        if (opts.required && !field.value) {
            errors[field.id] = opts.emptyMsg ?? 'Field is required';
            return;
        }

        switch (opts.type) {
            case 'firstName':
            case 'lastName':
                this.validateNameField(field, errors, opts.type, opts.regex, opts.invalidMsg);
                break;
            case 'email':
                this.validateEmailField(field, errors, opts.regex, opts.invalidMsg);
                break;
            case 'confirmEmail':
                if (opts.matchFieldId) {
                    this.validateConfirmEmail(field, errors, opts.matchFieldId, opts.mismatchMsg);
                }
                break;
        }
    }

    private clearFieldError(fieldId: string) {
        if (!fieldId) return;

        const field = document.getElementById(fieldId);
        const fieldError = document.getElementById(`${fieldId}-error-msg`);

        field?.classList?.remove("invalid-field");
        fieldError?.classList?.add('hidden');
    }

    private hideError(id: string) {
        if (!id) return;

        const fieldError = document.getElementById(`${id}-error-msg`);
        fieldError?.classList?.add('hidden');
    }

    private handleMobileInput(e: Event): void {
        e.preventDefault();

        const phoneNumberInput = document.getElementById('purchaser-phone-number') as HTMLInputElement | null;
        if (!phoneNumberInput) return;

        const reg = REGEX.mobileNumberRegex;
        const val = phoneNumberInput?.value || '';
        const digits = val?.replace(/\D/g, '');
        const match = reg?.exec(digits || '');

        if (val && val?.length < 14 && (!match || match[0].length < 10)) {
            const fieldError = document.getElementById('purchaser-phone-number-error-msg');
            if (fieldError) {
                fieldError.textContent = 'Invalid phone format.';
                fieldError.classList.remove('hidden');
            }
        } else {
            this.hideError('purchaser-phone-number');
        }

        if (match) {
            let formattedNumber: string;
            if (!match[2]) {
                formattedNumber = match[1];
            } else {
                const extension = match[3] ? `-${match[3]}` : '';
                formattedNumber = `(${match[1]}) ${match[2]}${extension}`;
            }
            phoneNumberInput.value = formattedNumber;
        }
    }

    private isValidForm(): boolean {
        // Hide all error messages and remove invalid field styling
        document.querySelectorAll('.error-msg').forEach(el => {
            if (el instanceof HTMLElement) {
                el.classList.add('hidden');
            }
        });

        document.querySelectorAll('.invalid-field').forEach(el => {
            el.classList.remove('invalid-field');
        });

        const errors: Record<string, string> = {};

        // Get form inputs with null checks
        const getInput = (id: string): HTMLInputElement | null =>
            document.getElementById(id) as HTMLInputElement | null;

        const firstNameInput = getInput('purchaser-first-name');
        const lastNameInput = getInput('purchaser-last-name');
        const phoneNumber = getInput('purchaser-phone-number');
        const emailInput = getInput('purchaser-email');
        const confirmEmailInput = getInput('purchaser-confirmemail');

        // Return early if required inputs are missing
        if (!firstNameInput || !lastNameInput || !phoneNumber || !emailInput || !confirmEmailInput) {
            console.error('One or more form inputs are missing');
            return false;
        }

        // Validate fields using generic validator
        this.validateField(firstNameInput, errors, {
            type: 'firstName',
            required: true,
            regex: REGEX.sendName,
            emptyMsg: 'Please enter a valid first name',
            invalidMsg: 'Please enter a valid first name'
        });
        this.validateField(lastNameInput, errors, {
            type: 'lastName',
            required: true,
            regex: REGEX.sendName,
            emptyMsg: 'Please enter a valid last name',
            invalidMsg: 'Please enter a valid last name'
        });
        this.validateField(emailInput, errors, {
            type: 'email',
            required: true,
            regex: REGEX.sendEmail,
            emptyMsg: 'Please enter a valid email address',
            invalidMsg: 'Please enter a valid email address'
        });
        this.validateField(confirmEmailInput, errors, {
            type: 'confirmEmail',
            required: true,
            matchFieldId: 'purchaser-email',
            emptyMsg: 'Please confirm the email address',
            mismatchMsg: 'Email addresses do not match'
        });
        if (phoneNumber?.required && !phoneNumber.value) {
            const errorMessage = document.getElementById(`${phoneNumber.id}-error-msg`)?.innerText ?? 'Please enter a valid Phone Number';
            errors[phoneNumber.id] = errorMessage;
        } else if (phoneNumber && phoneNumber?.required && phoneNumber.value.length < this.PHONE_NUMBER_LENGTH) {
            errors[phoneNumber.id] = "Please enter a valid Phone Number";
        }

        // Focus and show errors
        this.showErrors(errors);

        return Object.keys(errors).length === 0;
    }
}